const menu = () => import(/* webpackChunkName: "Menu" */ "@/views/menu/Menu");
const menuUpload = () => import(/* webpackChunkName: "Menu Upload" */ "@/views/menu/MenuUpload");

const menuRoutes = [
  {
    path: "menu",
    name: "menu",
    redirect: {
      name: "Menu Upload"
    },
    component: menu,
    children: [
      {
        path: "upload",
        name: "Menu Upload",
        component: menuUpload
      }
    ]
  }
];

export default menuRoutes;